import React, { useEffect } from "react";
import AppScreen from "./AppScreen";
import { MailIcon, LinkedInIcon, FacebookIcon, DiscordIcon } from "./Icons";
const ContactSection = () => {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const contacts = [
    {
      link: "mailto:purnanshuborkarofficial@gmail.com",
      linkName: "Mail",
      icon: <MailIcon />,
    },
    {
      link: "https://discord.com/invite/MMYUXPqjwx",
      linkName: "Discord",
      icon: <DiscordIcon />,
    },
    {
      link: "https://www.linkedin.com/groups/13999769/",
      linkName: "LinkedIn",
      icon: <LinkedInIcon />,
    },
    {
      link: "https://www.facebook.com/groups/902811997286238/",
      linkName: "Facebook",
      icon: <FacebookIcon />,
    },
  ];

  return (
    <AppScreen>
      <section className="w-11/12 sm:w-8/12 p-4 my-24 mx-auto bg-white rounded-lg">
        <h1 className="text-center text-xl sm:text-3xl font-semibold my-10">
          For any queries, feel free to contact at the links below:
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 justify-items-center items-center text-sm ">
          {contacts.map((item) => (
            <ContactLink
              link={item.link}
              Icon={item.icon}
              linkName={item.linkName}
            />
          ))}
          <span
            id="contactCopyTooltip"
            className="bg-green-500 text-white py-1 px-2 text-center text-sm font-semibold rounded-full absolute transition-opacity opacity-0 ease-in-out"
          >
            Link Copied!
          </span>
        </div>
      </section>
    </AppScreen>
  );
};

export default ContactSection;

const ContactLink = ({ link, linkName, Icon }) => {
  return (
    <>
      <div
        className="m-3 cursor-pointer flex flex-col w-1/2 sm:w-4/12 sm:flex-row items-center"
        onClick={(e) => copyToClip(e, link)}
      >
        <div className="pointer-events-none">
          <div className="text-6xl text-gray-800">{Icon}</div>
        </div>
        <span className="sm:pl-4 leading-loose font-semibold text-gray-700 text-base pointer-events-none">
          {linkName}
        </span>
      </div>
    </>
  );
};

const copyToClip = (e, link) => {
  e.preventDefault();

  navigator.clipboard.writeText(link);

  const currentPos = e.target.getBoundingClientRect();

  const toolTip = document.getElementById("contactCopyTooltip");

  toolTip.style.top = `${
    currentPos.y + currentPos.height / (window.innerWidth < 640 ? 1 : 4)
  }px`;

  if (window.innerWidth > 640) {
    toolTip.style.left = `${currentPos.left + currentPos.width * 1.3}px`;
  } else {
    toolTip.style.left = `${currentPos.left + currentPos.width / 2}px`;
    toolTip.style.transform = "translateX(-50%)";
  }

  toolTip.classList.add("opacity-100");

  setTimeout(() => {
    toolTip.classList.remove("opacity-100");
  }, 1000);
};
